
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns1337f77e155ccaa7ba0ffc2a28a5711cen from './en.yaml'
            i18n.addResourceBundle('en', '1337f77e155ccaa7ba0ffc2a28a5711c', flattenObject(ns1337f77e155ccaa7ba0ffc2a28a5711cen), true, true);
        
        export default '1337f77e155ccaa7ba0ffc2a28a5711c';
    